// Função para criar um timeout para a requisição
const fetchWithTimeout = async (url, options, timeout = 5000) => {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), timeout);

  try {
    const response = await fetch(url, {
      ...options,
      signal: controller.signal
    });
    clearTimeout(timeoutId);
    return response;
  } catch (error) {
    clearTimeout(timeoutId);
    throw error;
  }
};

export const checkBackendConnectivity = async () => {
  try {
    // Verifica o estado da rede do navegador primeiro
    if (!navigator.onLine) {
      return false;
    }

    const response = await fetchWithTimeout('https://be.manejechat.com/', {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Cache-Control': 'no-cache'
      }
    })
    
    if (!response.ok) {
      return false;
    }

    const data = await response.json();
    return data.status === 'OK';
  } catch (error) {
    console.error('Backend connectivity check failed:', error);
    return false;
  }
};
